import DashboardOpportunity from './DashboardOpportunity';
export default DashboardOpportunity;
